export class CostDataRecordCost {
    'meteringDimension';
    'cost';
    'usage';
    'metadata';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "meteringDimension",
            "baseName": "meteringDimension",
            "type": "MeteringDimension",
            "format": ""
        },
        {
            "name": "cost",
            "baseName": "cost",
            "type": "Cost",
            "format": ""
        },
        {
            "name": "usage",
            "baseName": "usage",
            "type": "Usage",
            "format": ""
        },
        {
            "name": "metadata",
            "baseName": "metadata",
            "type": "CostRecordMetadata",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CostDataRecordCost.attributeTypeMap;
    }
    constructor() {
    }
}
